<template>
    <div id="app">
        <div class="app-background"></div>
        <Header />
        <Home v-if="$route.path === '/'" />
        <transition name="page-zoom">
            <router-view :key="$route.fullPath" />
        </transition>
    </div>
</template>

<script>
import Header from './components/Header'
import Home from './components/Home'

export default {
    name: 'app',

    components: {
        Header,
        Home
    }
}
</script>

<style lang="scss">
    @import '@/styles/main.scss';
</style>
